import React from "react";

export default function UsageRing({ used = 0, limit = 10, size = 56, strokeWidth = 4.5, fontSize = 13 }) {
  const isUnlimited = limit === -1;
  const ratio = isUnlimited ? 0.3 : Math.min(used / limit, 1);
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - ratio);

  let strokeColor = "var(--rolex-green)";
  if (!isUnlimited) {
    if (ratio >= 1) strokeColor = "var(--error)";
    else if (ratio >= 0.8) strokeColor = "var(--rolex-gold)";
  }

  return (
    <div className="usage-ring" style={{ width: size, height: size }}>
      <svg width={size} height={size}>
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          fill="none"
          stroke="var(--surface-border)"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          fill="none"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.6s ease, stroke 0.3s ease" }}
        />
      </svg>
      <span
        className="absolute font-semibold"
        style={{ fontSize, color: "var(--text-primary)" }}
      >
        {isUnlimited ? "\u221E" : used}
      </span>
    </div>
  );
}
